// Generated by scripts/icons.mjs from design/icons/*.svg. Do not edit; run `npm run icons`.
export const iconPaths = {
    back: 'M15 6l-6 6 6 6',
    calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
    camera: 'M4 8h3l1.5-2.5h7L17 8h3v11H4zM8.5 13a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0z',
    check: 'M5 12.5l4.5 4.5L19 7',
    chevron: 'M9 6l6 6-6 6',
    chore: 'M4 20l8-8M9 9l6 6M9.5 9.5 12 7M12 12l2.5-2.5M14.5 14.5 17 12',
    close: 'M6 6l12 12M18 6 6 18',
    down: 'M6 9l6 6 6-6',
    edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
    fed: 'M9 3h6M10 3v6l-5 9.2A2 2 0 0 0 6.8 21h10.4a2 2 0 0 0 1.8-2.8L14 9V3M7.2 15h9.6',
    filter: 'M4 6h16M7 12h10M10 18h4',
    flip: 'M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M18 3v4h-4M6 21v-4h4',
    garden: 'M3.5 15h17v3.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z M8 15v-2.5M12 15V9M16 15v-2.5 M12 11.5c-2 0-3-1-3-3 2 0 3 1 3 3zM12 10c0-2 1-3 3-3 0 2-1 3-3 3z',
    gave: 'M4 9.5h16V14H4zM5.5 14h13v7h-13zM12 9.5V21M12 9.5C10 5.5 6.5 5.5 6.5 7.5S12 9.5 12 9.5zM12 9.5c2-4 5.5-4 5.5-2S12 9.5 12 9.5z',
    happy: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18z M8.3 14.2c.9 1.5 2.2 2.3 3.7 2.3s2.8-.8 3.7-2.3 M9 9.3v1.2M15 9.3v1.2',
    harvest: 'M3 10h18l-2 9.5H5zM7 10c0-3 2.2-5 5-5s5 2 5 5M9 13.5v3M12 13.5v3M15 13.5v3',
    hash: 'M5 9h14M5 15h14M10 4 8 20M16 4l-2 16',
    journal: 'M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM5 17a3 3 0 0 1 3-3h11M9 8h6',
    leaf: 'M5 19C5 11 10 5 19 5c0 9-6 14-14 14zM5 19l8-8',
    lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
    made: 'M3.5 11h17a8.5 8.5 0 0 1-17 0zM9 3.5c-1 1.5 1 2.5 0 4M13 3.5c-1 1.5 1 2.5 0 4',
    map: 'M3 6l6-2.5 6 2.5 6-2.5v14.5l-6 2.5-6-2.5-6 2.5zM9 3.5V18M15 6v14.5',
    measured: 'M3 17 17 3l4 4L7 21zM7 13l2 2M10 10l2 2M13 7l2 2',
    more: 'M4 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0zM17 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0z',
    note: 'M6 3h9l3 3v15H6zM15 3v3h3M9 11h6M9 14.5h6M9 18h3.5',
    pin: 'M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11zM10 10a2 2 0 1 0 4 0 2 2 0 1 0-4 0z',
    planted: 'M5 20h14M12 20v-8M12 13c-4 0-6-2-6-6 4 0 6 2 6 6zM12 11c0-3.5 2-5.5 6-5.5 0 3.5-2 5.5-6 5.5z',
    plus: 'M12 5v14M5 12h14',
    potted: 'M5 11h14v2.5H5zM6.5 13.5 7.7 20h8.6l1.2-6.5M12 11V7.5M12 8c-2.5 0-3.5-1.5-3.5-4 2.5 0 3.5 1.5 3.5 4z',
    problem: 'M4.5 10.5a6 6 0 1 0 12 0 6 6 0 1 0-12 0zM15 15l5 5M10.5 7.8v3.2M10.5 13.3v.2',
    progress: 'M4 8h3l1.5-2.5h7L17 8h3v11H4zM8.5 13a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0z',
    pruned: 'M3 6a3 3 0 1 0 6 0 3 3 0 1 0-6 0zM3 18a3 3 0 1 0 6 0 3 3 0 1 0-6 0zM8.3 7.8 20 18M8.3 16.2 20 6',
    reminder: 'M6 16v-5a6 6 0 0 1 12 0v5l1.5 2.5h-15zM10 21h4',
    seed: 'M6 3h12v18H6zM6 7.5h12M12 11c-1.7 0-3 1.6-3 3.6s1.3 3.6 3 3.6 3-1.6 3-3.6-1.3-3.6-3-3.6zM12 11v7.2',
    share: 'M12 3v12M7.5 7.5 12 3l4.5 4.5M5 13v7h14v-7',
    sowed: 'M3 11h18M12 12.8c1.4 0 2.5 1.4 2.5 3.2s-1.1 3.2-2.5 3.2-2.5-1.4-2.5-3.2 1.1-3.2 2.5-3.2zM12 3v5M9.5 5.5 12 8l2.5-2.5',
    tree: 'M12 21v-6M12 15c-4.5 0-7-2.5-7-6a7 7 0 0 1 14 0c0 3.5-2.5 6-7 6zM9 21h6',
    watered: 'M12 3.5s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11zM9 15a3 3 0 0 0 3 3',
    weather: 'M7 19a4 4 0 0 1-.4-8A5.5 5.5 0 0 1 17 9.5 4.75 4.75 0 0 1 17 19z',
} as const;

export type IconName = keyof typeof iconPaths;
